import { render, staticRenderFns } from "./comp_AppBar-Bottom-MenuItems.vue?vue&type=template&id=15a4ba76&scoped=true&"
import script from "./comp_AppBar-Bottom-MenuItems.vue?vue&type=script&lang=js&"
export * from "./comp_AppBar-Bottom-MenuItems.vue?vue&type=script&lang=js&"
import style0 from "./comp_AppBar-Bottom-MenuItems.vue?vue&type=style&index=0&id=15a4ba76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4ba76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VMenu})
